import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  const featured = comics.filter(c => c.rating >= 4.7).slice(0, 6);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选高分韩国漫画，品质保证</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <Link
          to="/category"
          className="sm:hidden mt-6 flex items-center justify-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}